export const LINK_TO_START_PAGE = '/';
export const LINK_TO_FAMILY_PAGE = '/personalia/familie';

export const TXT_PRICE_VALID_FOR = 'Prisen gjelder per medlemskapsår';
export const TXT_ENKELTMEDLEMSKAP_DESCRIPTION =
    'Medlemskap for én person. Pris settes og justeres etter medlemmets alder.';
